module.exports = ".modal-body {\n  padding: 25px 58px 30px 58px;\n  font-size: 1.02rem; }\n\np,\nspan {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.38); }\n\n.note {\n  font-size: 11px;\n  color: gray;\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: -20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirm-modal/confirm-modal.component.scss
// module id = ./src/app/shared/components/confirm-modal/confirm-modal.component.scss
// module chunks = main